export class saveEV{              
    remediationraised: any| undefined;
    DoAccManage: any| undefined;
    DoAccManageIV:any| undefined;
    AppliedCorrAction: any| undefined;
    ClientAppExcep: any| undefined;
    ClientInf: any| undefined;
    ClientImp: any| undefined;
    VulRecordStatus : any| undefined;
    cve:any| undefined;
    Contract_Number:any| undefined;
    MitigationComment:any|undefined;
    
    UpdatedBy : any| undefined;
}